import { render, staticRenderFns } from "./ProjectEstimates.vue?vue&type=template&id=4e5425c8"
import script from "./ProjectEstimates.vue?vue&type=script&lang=js"
export * from "./ProjectEstimates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports